import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TarActionItemCode } from '@ekhodealer/ekho-common';

import type { SubmitSignedTarPaperworkResponse } from '@ekhodealer/ekho-common';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { apiClient } from '@config/server/apiClient';
import { ordersEndpoints } from '@config/server/apiEndpoints';

import { updateProgressCache } from './progressCacheUtils';


export interface SubmitSignedTarPaperworkInput {
	finalSignedTarPaperworkScan: {
		base64Data: string;
		type: string;
		name: string;
	};
}

export const submitSignedTarPaperwork = async (
	servicesProviderId: string,
	orderId: string,
	data: SubmitSignedTarPaperworkInput,
): Promise<SubmitSignedTarPaperworkResponse> => {
	const response = await apiClient.post<SubmitSignedTarPaperworkResponse>(
		ordersEndpoints.submitSignedTarPaperwork(servicesProviderId, orderId),
		data,
	);
	return response.data;
};

export const useSubmitSignedTarPaperwork = (orderId: string | undefined) => {
	const servicesProviderId = useCurrentServicesProviderId();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (input: SubmitSignedTarPaperworkInput) => {
			if (!orderId || !servicesProviderId) {
				throw new Error(
					'Unable to submit signed TAR paperwork without an order ID or services provider ID.',
				);
			}

			return submitSignedTarPaperwork(servicesProviderId, orderId, input);
		},
		onSuccess: (data) => {
			if (!orderId || !servicesProviderId) return;
			updateProgressCache(queryClient, servicesProviderId, orderId, data.progress, TarActionItemCode.SUBMIT_SIGNED_TAR_PAPERWORK);
		},
	});
};
